import React from 'react';
import { FormikValues } from 'formik';
import { Typography } from '@material-ui/core';

import { LEGAL } from 'constants/index';
import { FullScreenCard, Loading } from 'components';
import useAuth from 'hooks/useAuth';

import SignupForm from './components/SignupForm';
import StripeCheckout, { CheckoutDetails } from './components/StripeCheckout';

const SignUp: React.FC = () => {
  const { isLoading, signUp, user, isAuthenticated, doesAccountExist } = useAuth();
  const [isSigningUp, setIsSigningUp] = React.useState(false);
  const [checkoutDetails, setCheckoutDetails] = React.useState<CheckoutDetails | undefined>(
    undefined,
  );
  const isContinuing = !isSigningUp && isAuthenticated && !doesAccountExist;

  const handleSignupStarted = async (values: FormikValues, itunesId: string, feedUrl: string) => {
    const { email, password, vanityUrl } = values;
    if (!isContinuing) {
      setIsSigningUp(true);
      await signUp(email, password);
    }
    setCheckoutDetails({ itunesId, vanityUrl, feedUrl });
  };

  const renderFooter = () => (
    <Typography variant="subtitle1">
      By proceeding, you agree to the{' '}
      <a href={LEGAL.TERMS} target="_blank" rel="noopener noreferrer">
        Terms of Service
      </a>{' '}
      and{' '}
      <a href={LEGAL.PRIVACY} target="_blank" rel="noopener noreferrer">
        Privacy Policy
      </a>
      .
    </Typography>
  );

  return (
    <FullScreenCard footer={renderFooter()}>
      {isSigningUp && isLoading && <Loading message="Creating your account..." />}
      {checkoutDetails && user && user.id && <StripeCheckout {...checkoutDetails} />}
      {!checkoutDetails && !isLoading && (
        <SignupForm isContinuing={isContinuing} onSubmit={handleSignupStarted} />
      )}
    </FullScreenCard>
  );
};

export default SignUp;
